import { render, staticRenderFns } from "./addWork.vue?vue&type=template&id=4f1cec4c&scoped=true"
import script from "./addWork.vue?vue&type=script&lang=js"
export * from "./addWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cec4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1cec4c')) {
      api.createRecord('4f1cec4c', component.options)
    } else {
      api.reload('4f1cec4c', component.options)
    }
    module.hot.accept("./addWork.vue?vue&type=template&id=4f1cec4c&scoped=true", function () {
      api.rerender('4f1cec4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/addWork.vue"
export default component.exports